module.exports = __webpack_public_path__ + "img/years-in-business.b7db6a5.webp";